import type { StateCreator } from 'zustand';

import type { StateSlices } from '..';

export type ResetSlice = {
  resetAllSlices: (resetUserState?: boolean) => void;
};

export const createResetSlice: StateCreator<StateSlices, [], [], ResetSlice> = (
  _set,
  get
) => ({
  resetAllSlices(resetUserState) {
    get().resetFilterSlice();
    get().resetSessionSlice();
    get().resetWorkflowStateSelectionSlice();
    get().resetTableGroupExpansionsSlice();
    get().resetDocumentSigningSlice();

    if (resetUserState) {
      get().resetUiSlice();
    }
  },
});
